import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

/**
 * A single shared signal of the current router URL for the nav menu tree.
 * MenuItemComponent renders itself recursively (one instance per menu node),
 * so without this each instance would open its own router.events
 * subscription — this gives the whole tree one subscription instead of N.
 */
@Injectable({
  providedIn: 'root',
})
export class NavActiveUrlService {
  private readonly router = inject(Router);

  readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url),
    ),
    { initialValue: this.router.url },
  );
}
